module.exports = __webpack_public_path__ + "avatar-ls.35703210.png";